import { motion } from 'motion/react';
import { useBrand } from '../context/BrandContext';
import { Anchor } from 'lucide-react';

export default function Legacy() {
  const { content } = useBrand();

  return (
    <section className="py-24 bg-ows-white overflow-hidden" id="legacy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <div className="flex items-center justify-center gap-3 text-ows-teal mb-8">
              <Anchor className="h-6 w-6" />
              <span className="text-xs font-bold tracking-[0.5em] uppercase font-mono">{content.dreamLabel}</span>
            </div>

            <h2 className="text-4xl md:text-6xl font-display font-light uppercase tracking-[0.2em] text-ows-dark leading-tight mb-12">
              {content.dreamTitle} <br />
              <span className="text-ows-teal italic font-normal lowercase font-display tracking-normal">{content.dreamSubtitle}</span>
            </h2>

            <p className="text-xl text-ows-dark/60 font-serif italic tracking-tight leading-relaxed max-w-3xl mx-auto mb-12">
              {content.dreamQuote}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 text-left border-t border-[#141414]/10 pt-16">
              <div>
                <h4 className="text-[10px] font-mono font-bold uppercase tracking-widest text-ows-teal mb-4">{content.cultureTitle || "THE CULTURE"}</h4>
                <p className="text-xs text-[#141414]/60 uppercase tracking-tighter leading-relaxed">
                  {content.cultureDesc || "We don't settle for calm waters. We seek the challenge of the swell and the silence of the night."}
                </p>
              </div>
              <div>
                <h4 className="text-[10px] font-mono font-bold uppercase tracking-widest text-ows-teal mb-4">{content.communityTitle || "THE COMMUNITY"}</h4>
                <p className="text-xs text-[#141414]/60 uppercase tracking-tighter leading-relaxed">
                  {content.communityDesc || "A collective of high-stakes professionals united by the discipline of the open water."}
                </p>
              </div>
              <div>
                <h4 className="text-[10px] font-mono font-bold uppercase tracking-widest text-ows-teal mb-4">{content.missionTitle || "THE MISSION"}</h4>
                <p className="text-xs text-[#141414]/60 uppercase tracking-tighter leading-relaxed">
                  {content.missionDesc || "To provide the education, the safety, and the network for serious aquatic exploration."}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
